var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vx-card",
        { staticClass: "mb-4" },
        [
          _c(
            "div",
            { staticClass: "flex flex-wrap items-center justify-between mb-4" },
            [
              _c("div", [
                _c("h4", { staticClass: "mb-1" }, [
                  _vm._v(_vm._s(_vm.$t("occupancy.title"))),
                ]),
                _c("div", { staticClass: "text-muted" }, [
                  _vm._v(_vm._s(_vm.$t("occupancy.subtitle"))),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "flex items-center gap-2" },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-0 mr-2",
                      attrs: {
                        label: _vm.$t("occupancy.weeks"),
                        "label-cols": "auto",
                        "label-size": "sm",
                      },
                    },
                    [
                      _c("b-form-select", {
                        attrs: { options: _vm.weekOptions, size: "sm" },
                        on: { change: _vm.load },
                        model: {
                          value: _vm.weeks,
                          callback: function ($$v) {
                            _vm.weeks = $$v
                          },
                          expression: "weeks",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "outline-primary", size: "sm" },
                      on: { click: _vm.load },
                    },
                    [
                      _c("feather-icon", {
                        staticClass: "mr-50",
                        attrs: { icon: "RefreshCwIcon" },
                      }),
                      _c("span", { staticClass: "align-middle" }, [
                        _vm._v("Atualizar"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm.summary
            ? _c(
                "div",
                { staticClass: "vx-row mb-4" },
                _vm._l(_vm.summaryCards, function (card) {
                  return _c(
                    "div",
                    {
                      key: card.label,
                      staticClass: "vx-col sm:w-1/5 w-1/2 mb-2",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "border rounded p-1 text-center" },
                        [
                          _c("div", { staticClass: "text-muted" }, [
                            _c("small", [_vm._v(_vm._s(card.label))]),
                          ]),
                          _c("div", { staticClass: "font-bold text-lg" }, [
                            _vm._v(_vm._s(card.value)),
                          ]),
                        ]
                      ),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm.weekdays.length === 0
            ? _c("div", { staticClass: "text-center text-muted p-4" }, [
                _vm._v(" " + _vm._s(_vm.$t("occupancy.empty")) + " "),
              ])
            : _vm._e(),
          _vm._l(_vm.weekdays, function (day) {
            return _c("div", { key: day.weekday, staticClass: "mb-3" }, [
              _c(
                "div",
                { staticClass: "font-bold border-b pb-1 mb-2 capitalize" },
                [_vm._v(_vm._s(day.label))]
              ),
              _c(
                "div",
                { staticClass: "occupancy-grid" },
                _vm._l(day.slots, function (slot) {
                  return _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.auto",
                          value: {
                            content: _vm.tooltipFor(slot),
                            delay: { show: 300, hide: 100 },
                          },
                          expression:
                            "{ content: tooltipFor(slot), delay: { show: 300, hide: 100 } }",
                          modifiers: { auto: true },
                        },
                      ],
                      key: slot.lessonId + "-" + slot.availableScheduleId,
                      staticClass: "occupancy-cell border rounded p-1",
                      class: _vm.rateClass(slot),
                      on: {
                        click: function ($event) {
                          return _vm.goToAgenda(slot)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex items-center justify-between" },
                        [
                          _c("span", { staticClass: "font-medium" }, [
                            _vm._v(_vm._s(slot.startTime)),
                          ]),
                          _c("span", { staticClass: "font-bold" }, [
                            _vm._v(
                              _vm._s(slot.rate === null ? "∞" : slot.rate + "%")
                            ),
                          ]),
                        ]
                      ),
                      _c("div", { staticClass: "text-muted truncate" }, [
                        _c("small", [_vm._v(_vm._s(slot.lessonName))]),
                      ]),
                      _c("div", { staticClass: "text-muted" }, [
                        _c("small", [
                          _vm._v(
                            " " +
                              _vm._s(slot.avgOccupied) +
                              "/" +
                              _vm._s(
                                slot.capacity === null ? "∞" : slot.capacity
                              ) +
                              " "
                          ),
                          slot.subscriptionTotal > 0
                            ? _c("span", [
                                _vm._v(
                                  " · " +
                                    _vm._s(slot.subscriptionTotal) +
                                    " fixos"
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ])
          }),
          _vm.weekdays.length
            ? _c("div", { staticClass: "flex flex-wrap gap-4 mt-3" }, [
                _c("span", { staticClass: "flex items-center gap-1" }, [
                  _c("span", { staticClass: "legend-dot rate-free" }),
                  _c("small", [
                    _vm._v(_vm._s(_vm.$t("occupancy.legend_free"))),
                  ]),
                ]),
                _c("span", { staticClass: "flex items-center gap-1" }, [
                  _c("span", { staticClass: "legend-dot rate-busy" }),
                  _c("small", [
                    _vm._v(_vm._s(_vm.$t("occupancy.legend_busy"))),
                  ]),
                ]),
                _c("span", { staticClass: "flex items-center gap-1" }, [
                  _c("span", { staticClass: "legend-dot rate-full" }),
                  _c("small", [
                    _vm._v(_vm._s(_vm.$t("occupancy.legend_full"))),
                  ]),
                ]),
              ])
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }